import { z } from 'zod';
import { UuidSchema } from '../_shared/ids.js';
import { ModuleKeySchema, UserRoleSchema } from './enums.js';
import { SiteBranding } from './site.js';
/**
 * Sesión del panel: quién soy, de qué medio y qué áreas tengo habilitadas.
 *
 * El panel necesita las tres cosas para armarse:
 *  - `role` decide qué áreas existen (ver `permisos.ts`). Va acá y **no** en el JWT: el rol puede
 *    cambiar y un access token de 15 minutos con el rol adentro se vuelve mentira.
 *  - `tenant` alimenta el lockup de marca (logo, nombre, dominio) y el color de identidad.
 *  - `modules` construye el menú. Un módulo apagado no registra ni el ítem ni la ruta.
 *  - `debeCambiarPassword` corta todo: mientras esté en `true` el panel no dibuja nada más que la
 *    pantalla de cambio de contraseña, y la API rechaza cualquier otro endpoint. Es el único
 *    endpoint que contesta en ese estado, así que el panel se entera acá.
 */
export const MeUser = z
    .object({
    id: UuidSchema,
    nombre: z.string(),
    email: z.string().email(),
    role: UserRoleSchema,
    debeCambiarPassword: z.boolean(),
})
    .strict();
/** Misma forma que la marca pública (`SiteBranding`): no se duplica el contrato. */
export const MeTenant = SiteBranding;
export const MeResponse = z
    .object({
    user: MeUser,
    tenant: MeTenant,
    modules: z.array(ModuleKeySchema),
})
    .strict();
